<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.pallets')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex xs12 sm3 md3">
                <va-input
                  v-model="palletParams.assembling_timeout"
                  :label="$t('tables.pallets.assembling_timeout')"
                >
                </va-input>
              </div>
              <div class="flex xs12 sm3 md3">
                <va-input
                  v-model="palletParams.minimum_assembly_time"
                  :label="$t('tables.pallets.minimum_assembly_time')"
                >
                </va-input>
              </div>
              <div class="flex xs12 sm3 md3">
                <va-select
                  :label="$t('tables.pallets.sort_type')"
                  v-model="palletParams.sort_type"
                  keyBy="id"
                  textBy="name"
                  :options="listSortTypes"
                />
              </div>
              <div class="flex md2 sm1 xs4">
                <va-toggle
                  v-model="palletParams.active"
                  :label="$t('forms.inputs.active')"
                  :color="$themes.secondary"
                  small
                />
              </div>
            </div>

            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="update()"
                >
                  {{ $t('menu.update') }}
                </va-button>

                <BackButton />
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import { showError } from '@/global'
import BackButton from '../../shared/BackButton'
import PalletTypeAPI from '@/services/PalletTypeAPI'
import SortTypesAPI from '@/services/SortTypesAPI'

export default {
  components: { BackButton },
  data () {
    return {
      palletParams: {
        id: '',
        assembling_timeout: '',
        sort_type: {},
        active: false
      },
      listSortTypes: [],
    }
  },

  mounted() {
    this.getPalletType(this.$route.params.id)

    SortTypesAPI.getAllSortTypes().then(response => {
      this.listSortTypes = response.data.sort_types
    })

  },

  methods: {
    async getPalletType(id) {
      await PalletTypeAPI.getPalletType(id).then(response => {
        this.palletParams = response.data.pallet_type
      })
    },

    async update () {
      await PalletTypeAPI.update(this.palletParams).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),

        this.$router.push('/admin/tables/pallets')
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>
